export default function Services() {
  return (
    <div className="page">
      <h2>Our Services</h2>
      <p>Detailed services content goes here.</p>
    </div>
  );
}
